import { Button, Grid, MenuItem } from "@mui/material";
import { isValid } from "date-fns";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../../../app/hooks";
import { TextFieldLight } from "../../../../../../../common/components/styled/styled";
import { OrderTesVariation } from "../../../../../orderTesVariation/OrderTesVariation";
import { FormKeys, WorkOfferType } from "../../helpers";
import {
  WORK_AGREEMENT_ACCEPTED,
  WORK_AGREEMENT_DECLINED,
} from "../../../../../constants";

interface Props {
  type: WorkOfferType;
}
export const TesRow = ({ type }: Props) => {
  const { t } = useTranslation();
  const [tesSettingsOpen, setTesSettingsOpen] = useState(false);

  const { watch, setValue, getValues } = useFormContext();

  const status = getValues("status");
  const isReadOnly: boolean =
    status === WORK_AGREEMENT_ACCEPTED ||
    status === WORK_AGREEMENT_DECLINED ||
    type !== WorkOfferType.New;

  const watchedStartDate = watch(FormKeys.WorkStarts);
  const validStartDate = isValid(watchedStartDate) ? watchedStartDate : null;

  const tesLocalized = useAppSelector((state) => state.localized.tes);
  const { tesId, tesVariation } = watch();

  const saveVariations = (newVariations: [string, string][]) => {
    setValue(FormKeys.TesVariation, newVariations);
  };

  const onClose = () => {
    setTesSettingsOpen(false);
  };

  return (
    <>
      <Grid container item xs={9} alignItems="center">
        <Grid item container>
          <TextFieldLight
            disabled
            select
            fullWidth
            sx={{
              width: "363px",
            }}
            size="small"
            name="tes"
            value={tesId}
            onChange={() => {}}
          >
            <MenuItem value={tesId}>{tesLocalized[tesId]}</MenuItem>
          </TextFieldLight>
          <Button
            sx={{ textTransform: "none", marginLeft: "0.5rem" }}
            variant="text"
            disabled={!tesId}
            onClick={() => {
              setTesSettingsOpen(type === WorkOfferType.New);
            }}
          >
            {t("common:settingsDots")}
          </Button>
        </Grid>
      </Grid>
      <OrderTesVariation
        tesId={tesId}
        variationDefaults={tesVariation}
        date={validStartDate}
        open={tesSettingsOpen}
        onClose={onClose}
        setTesVariation={saveVariations}
        isReadOnly={isReadOnly}
      />
    </>
  );
};
